// extracted by mini-css-extract-plugin
export default {"thumb":"b_gOpALaxsqeT4TmkmQR"};